<script>
  import { fade } from 'svelte/transition';

  export let value;
  export let placeholder;
  export let error = false;
</script>

<div class="form-field">
  <textarea class="form-field__input" cols="30" rows="10" bind:value {placeholder} />
  {#if error}
    <span class="form-field__error text-small" transition:fade>{error}</span>
  {/if}
</div>

<style lang="scss">
  .form-field {
    position: relative;

    &__input {
      resize: none;
      width: 100%;

      padding: 3rem 4rem;
      border-radius: 1rem;

      color: var(--royal);
      background-color: rgb(var(--white));

      &::placeholder {
        color: var(--royal-light);
      }
    }

    &__error {
      position: absolute;
      right: 2rem;
      bottom: 1.5rem;

      color: var(--red);
    }
  }
</style>
